import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { SecondaryBtnsComponent } from '@enginuity/core/molecules/secondary-btns/secondary-btns.component';

@Component({
  selector: 'app-package-dropdown',
  templateUrl: './package-dropdown.component.html',
  styleUrls: ['./package-dropdown.component.scss'],
  imports: [CommonModule, CeIconComponent, SecondaryBtnsComponent],
})
export class PackageDropdownComponent {
  @Output() onClick = new EventEmitter<object>();
  @Output() setup = new EventEmitter<object>();
  @Input()
  selectedpackage: string = '';

  @Output() selectionChanged = new EventEmitter<string>();
  onItemSelected(selectedValue: string) {
    this.selectedpackage = selectedValue;
    this.selectionChanged.emit(selectedValue);
  }
  onSetupNowClick() {
    this.setup.emit();
  }
  @Input()
  package: any = [
    {
      icon: 'settings',
      label: 'Custom',
      tagLine: '',
      showButton: false,
    },
    {
      icon: 'subscription',
      label: 'Automatic',
      tagLine: 'You need to set up boxes to use this feature',
      showButton: true,
    },
  ];
}
